export default {"src":"/_next/static/image/public/images/flags/flag_596.215ea103828389f71ce6275c54c3fd5d.svg","height":16,"width":24};